import Code from 'eflex/models/code';

export default class RejectCode extends Code {}
